import { render, staticRenderFns } from "./adddetail.vue?vue&type=template&id=784a2d08&scoped=true"
import script from "./adddetail.vue?vue&type=script&lang=js"
export * from "./adddetail.vue?vue&type=script&lang=js"
import style0 from "./adddetail.vue?vue&type=style&index=0&id=784a2d08&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a2d08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784a2d08')) {
      api.createRecord('784a2d08', component.options)
    } else {
      api.reload('784a2d08', component.options)
    }
    module.hot.accept("./adddetail.vue?vue&type=template&id=784a2d08&scoped=true", function () {
      api.rerender('784a2d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/adddetail.vue"
export default component.exports